import { RouterView } from "vue-router";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildCards,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { EntityAudit } from "@modernary/mui/components/audit";
// Troubleshoot your routes using this - https://paths.esm.dev

/** @type {import('vue-router').RouterOptions['routes']} */

const names = {
  grants: "Grant.Grants",
  list: "Grant.GrantList",
  new: "Grant.GrantNew",
  base: "Grant.GrantBase",
  view: "Grant.GrantView",
  edit: "Grant.GrantEdit",
  projects: "Grant.GrantProjects",
  accounts: "Grant.GrantAccounts",
  notes: "Grant.GrantNotes",
  noteEdit: "Grant.GrantNoteEdit",
  noteNew: "Grant.GrantNoteNew",
  documents: "Grant.GrantDocuments",
  documentEdit: "Grant.GrantDocumentEdit",
  documentNew: "Grant.GrantDocumentNew",
  audit: "Grant.GrantAudit",
  contacts: "Grant.GrantContacts",
  contactEdit: "Grant.GrantContactEdit",
  contactNew: "Grant.GrantContactNew",
};

export { names as grantRouteNames };

const grantRoutes = [
  {
    path: "/grant",
    name: names.grants,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Grants", lookupGroups: ["GrantStatus", "GrantType"] },
        component: () => import("@/views/grant/GrantList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/grant/GrantBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Grant", isNew: true },
            component: () => import("@/views/grant/GrantEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/grant/GrantBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Grant View" },
            component: () => import("@/views/grant/GrantView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Grant Edit", isForm: true },
            component: () => import("@/views/grant/GrantEdit.vue"),
          },
          {
            path: "contacts",
            name: names.contacts,
            meta: { title: "Grant Contacts" },
            component: () => import("@/views/grant/GrantContacts.vue"),
          },
          {
            path: "projects",
            name: names.projects,
            meta: { title: "Grant Projects" },
            component: () => import("@/views/grant/ProjectChildList.vue"),
          },
          {
            path: "accounts",
            name: names.accounts,
            meta: { title: "Grant Accounts" },
            component: () => import("@/views/grant/AccountChildList.vue"),
          },
          {
            path: "contacts/:contactId(\\d+)",
            name: names.contactEdit,
            meta: { title: "Edit Grant Contact", isForm: true },
            component: () => import("@/views/grant/GrantContact.vue"),
          },
          {
            path: "contacts/new",
            name: names.contactNew,
            meta: { title: "Create Grant Contact", isForm: true },
            component: () => import("@/views/grant/GrantContact.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Grant Notes" },
            component: {
              render: () => <EntityNotes idField="grantId" routeNamePrefix="Grant.GrantNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Grant Note", isForm: true },
            component: () => import("@/views/grant/GrantNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Grant Note", isForm: true },
            component: () => import("@/views/grant/GrantNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Grant Documents" },
            component: {
              render: () => <EntityDocumentsChildCards resourceTypeKey="grant" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit Grant Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="grant" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create Grant Document", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="grant" />,
            },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Grant Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Grant" />,
            },
          },
        ],
      },
    ],
  },
];
export default grantRoutes;
